import request from "@/utils/request";

// 上传图片
export function uploadImage(img) { 
  return request.post(`/sport-manage/classDetail/image/upload`, img)
}

// 上传视频
export function uploadVideo(file) { 
  return request.post(`/sport-manage/classDetail/video/upload`, file)
}